<template>
  <div class="ym_footer ym_footer_pt20 ym_mt20">
    <div class="ym_layout">
      <div class="ym_fl">
        <div class="ym_fl ym_footlist ym_footicon">
          <img src="/static/img/blue.png" alt="备案信息" />
        </div>
        <div class="ym_fl ym_footlist ym_com">
          <ul>
            <li><a href="https://beian.miit.gov.cn/" target="_blank">黑ICP备2021001501号</a></li>
          </ul>
        </div>
        <div class="ym_fl ym_footnav">
          <p>联系地址：黑龙江省双鸭山市尖山区益人路与七马路交叉口</p>
        </div>
      </div>
      <div class="ym_rt ym_ewm">
         <img src="/static/img/logo.png" style="width: 100%;height: 100%;display: block;" />
      </div>
      <div class="ym_rt ym_footlist">
        <ul>
          <li><a>联系电话：</a></li>
          <li style="color:#c2e5f0">0469-4223199<br>0469-6135300<br>0469-6130310</li>
        </ul>
      </div>
      <div style="clear: both;"></div>
<!--      <div class="ym_foot_bot">-->
<!--        <p>总访问<span>{{ totalVisits }}</span>人 <span>当日访问量<span>{{ todayVisits }}</span>人</span> 本站已支持IPv6</p>-->
<!--        <p>Copyright © 2023 Linyi Development & Reform Commission All Rights Reserved</p>-->
<!--      </div>-->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      totalVisits: 1234,
      todayVisits: 56
    }
  }
}
</script>

<style scoped>
.ym_htgl {
  text-decoration: underline;
}

.ym_htgl:hover {
  color: red;
  text-decoration: underline;
}

.ym_footicon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.ym_footicon img {
  width: 80px;
  height: 80px;
}
</style>